import React from "react";
import { Platforms } from "../components/Platforms";

export default function PlatformsIndex() {
  return (
    <>
      <section className="pagehead">
        <div className="container">
          <div className="pagehead-inner">
            <div>
              <div className="section-label"><span className="dot" />Platforms</div>
              <h1 className="pagehead-title display" data-testid="platforms-index-h1">
                Eight products. <em>One cognitive substrate</em> for capital.
              </h1>
            </div>
            <p className="pagehead-lede">
              Four consulting platforms form our strategic layer. Four enterprise digital platforms form the execution layer. Each is composable — deploy one, or deploy the stack.
            </p>
          </div>
        </div>
      </section>
      <Platforms heading={false} />
    </>
  );
}
